module.exports = __webpack_public_path__ + "img/slide3-min.ed7f32e6.png";